import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";  
import { API_URL } from "../../constants/API_URL";
import { BirebirResponseModal, OgrenciSinavListesiResponseModal, SinavDetayResponseModal, SinavListesiResponseModal, SinavResponseModal } from "../../types/modals"; 
import { SinavRequestModal } from "../../types/RequestModals/SinavRequestModal";
import { SinavError } from "../../types/ErrorModals/SinavError";
import { SinavDetayRequestModal } from "../../types/RequestModals/SinavDetayRequestModal";
import { SinavListesiRequestModal } from "../../types/RequestModals/SinavListesiRequestModal";
import { OgrenciSinavListesiRequestModal } from "../../types/RequestModals/OgrenciSinavListesiRequestModal";
import { SertifikaRequestModal } from "../../types/RequestModals/SertifikaRequestModal";
import { TopluSertifikaRequestModal } from "../../types/RequestModals/TopluSertifikaRequestModal";

export const getSinav = async (request: SinavRequestModal): Promise<SinavResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<SinavResponseModal[]>>(
      `${API_URL}/api/sinav/getSinav`,
      request
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;

      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Sınav listesi bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavError;
      }

      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as SinavError;
      }

      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as SinavError;
    }

    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as SinavError;
  }
};

export const getSinavDetay = async (request: SinavDetayRequestModal): Promise<SinavDetayResponseModal> => {
  try {
    const response = await axios.post<ApiResponse<SinavDetayResponseModal>>(
      `${API_URL}/api/sinav/getSinavDetay`,
      request
    );

    if (!response.data.success) {
      throw new Error(response.data.message);
    }

    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;

      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Sınav detayı bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavError;
      }

      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as SinavError;
      }

      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as SinavError;
    }

    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as SinavError;
  }
};

export const getSinavSonucPdf = async (request: SinavDetayRequestModal): Promise<Blob> => {
  try {
    const response = await axios.post(
      `${API_URL}/api/sinav/getSinavSonucPdf`,
      request,
      {
        responseType: 'arraybuffer'
      }
    );

    // PDF response için özel kontrol
    if (response.headers['content-type'] === 'application/json') {
      // Eğer JSON hata mesajı döndüyse
      const errorData = JSON.parse(
        new TextDecoder().decode(response.data)
      ) as ApiResponse;

      if (!errorData.success) {
        throw new Error(errorData.message);
      }
    }

    return new Blob([response.data], { type: 'application/pdf' });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      let responseData: ApiResponse | undefined;

      // Response türüne göre parse işlemi
      if (axiosError.response?.data instanceof ArrayBuffer) {
        responseData = JSON.parse(
          new TextDecoder().decode(axiosError.response.data)
        );
      } else {
        responseData = axiosError.response?.data;
      }

      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "PDF bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavError;
      }

      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as SinavError;
      }

      throw {
        message: responseData?.message || "PDF oluşturulurken bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as SinavError;
    }

    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as SinavError;
  }
};

export const getFinalSinav = async (request: SinavRequestModal): Promise<SinavResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<SinavResponseModal[]>>(
      `${API_URL}/api/sinav/getFinalSinav`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Final sınav listesi bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as SinavError;
      }
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as SinavError;
    }
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as SinavError;
  }
};

export const getFinalSinavSonucPdf = async (request: SinavDetayRequestModal): Promise<Blob> => {
  try {
    const response = await axios.post(
      `${API_URL}/api/sinav/getFinalSinavSonucPdf`,
      request,
      {
        responseType: 'arraybuffer'
      }
    );
    // PDF response için özel kontrol
    if (response.headers['content-type'] === 'application/json') {
      // Eğer JSON hata mesajı döndüyse
      const errorData = JSON.parse(
        new TextDecoder().decode(response.data)
      ) as ApiResponse;
      if (!errorData.success) {
        throw new Error(errorData.message);
      }
    }
    return new Blob([response.data], { type: 'application/pdf' });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      let responseData: ApiResponse | undefined;
      // Response türüne göre parse işlemi
      if (axiosError.response?.data instanceof ArrayBuffer) {
        responseData = JSON.parse(
          new TextDecoder().decode(axiosError.response.data)
        );
      } else {
        responseData = axiosError.response?.data;
      }
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Final PDF bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as SinavError;
      }
      throw {
        message: responseData?.message || "Final PDF oluşturulurken bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as SinavError;
    }
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as SinavError;
  }
};

export const getSinavListesiBySezon = async (request: SinavListesiRequestModal): Promise<SinavListesiResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<SinavListesiResponseModal[]>>(
      `${API_URL}/api/sinav/getSinavListesiBySezon`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Sınav listesi bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavError;
      }
      throw {
        message: responseData?.message || "Sınav listesi getirilirken bir hata oluştu",
        correlationId: responseData?.correlationId,
      } as SinavError;
    }
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as SinavError;
  }
};

export const getOgrenciListesiBySinav = async (request: OgrenciSinavListesiRequestModal): Promise<OgrenciSinavListesiResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<OgrenciSinavListesiResponseModal[]>>(
      `${API_URL}/api/sinav/getOgrenciListesiBySinav`,
      request
    );
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Öğrenci listesi bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavError;
      }
      throw {
        message: responseData?.message || "Öğrenci listesi getirilirken bir hata oluştu",
        correlationId: responseData?.correlationId,
      } as SinavError;
    }
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as SinavError;
  }
};
 
export const getTopluFinalSinavPdf = async (request: OgrenciSinavListesiRequestModal): Promise<Blob> => {
  try {
    const response = await axios.post(
      `${API_URL}/api/sinav/getTopluFinalSinavPdf`,
      request,
      {
        responseType: 'arraybuffer' // Bu çok önemli!
      }
    );

    // API'nin PDF yerine JSON hata döndürme ihtimaline karşı
    if (response.headers['content-type'] === 'application/json') {
      const errorData = JSON.parse(
        new TextDecoder().decode(response.data)
      ) as ApiResponse;
      throw new Error(errorData.message || "PDF oluşturulurken bir hata oluştu.");
    }

    return new Blob([response.data], { type: 'application/pdf' });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      let responseData: ApiResponse | undefined;
      
      // Hata cevabı da arraybuffer olabilir, onu parse etmeliyiz
      if (axiosError.response?.data instanceof ArrayBuffer) {
        try {
          responseData = JSON.parse(
            new TextDecoder().decode(axiosError.response.data)
          );
        } catch (parseError) {
          // Parse edilemezse genel hata
        }
      } else {
        responseData = axiosError.response?.data;
      }

      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Toplu PDF için veri bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavError;
      }
      
      throw {
        message: responseData?.message || "Toplu PDF oluşturulurken bir hata oluştu",
        correlationId: responseData?.correlationId,
      } as SinavError;
    }
    // Axios dışı veya JSON parse hatası
    throw { 
      message: (error as Error).message || "Beklenmeyen bir hata oluştu"
    } as SinavError;
  }
};

export const getTekliSertifikaPdf = async (request: SertifikaRequestModal): Promise<Blob> => {
  try {
    const response = await axios.post(
      `${API_URL}/api/sinav/getTekliSertifikaPdf`,
      request,
      {
        responseType: 'arraybuffer'
      }
    );
    // PDF response için özel kontrol
    if (response.headers['content-type'] === 'application/json') {
      const errorData = JSON.parse(
        new TextDecoder().decode(response.data)
      ) as ApiResponse;
      if (!errorData.success) {
        throw new Error(errorData.message);
      }
    }
    return new Blob([response.data], { type: 'application/pdf' });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      let responseData: ApiResponse | undefined;
      if (axiosError.response?.data instanceof ArrayBuffer) {
        try {
          responseData = JSON.parse(
            new TextDecoder().decode(axiosError.response.data)
          );
        } catch (parseError) {
          // Parse edilemezse genel hata
        }
      } else {
        responseData = axiosError.response?.data;
      }
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Sertifika PDF bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as SinavError;
      }
      throw {
        message: responseData?.message || "Sertifika PDF oluşturulurken bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData
      } as SinavError;
    }
    throw { 
      message: "Beklenmeyen bir hata oluştu"
    } as SinavError;
  }
};

export const getTopluSertifikaPdf = async (request: TopluSertifikaRequestModal): Promise<Blob> => {
  try {
    const response = await axios.post(
      `${API_URL}/api/sinav/getTopluSertifikaPdf`,
      request,
      {
        responseType: 'arraybuffer'
      }
    );
    // PDF response için özel kontrol
    if (response.headers['content-type'] === 'application/json') {
      const errorData = JSON.parse(
        new TextDecoder().decode(response.data)
      ) as ApiResponse;
      throw new Error(errorData.message || "Toplu sertifika PDF oluşturulurken bir hata oluştu.");
    }
    return new Blob([response.data], { type: 'application/pdf' });
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      let responseData: ApiResponse | undefined;
      if (axiosError.response?.data instanceof ArrayBuffer) {
        try {
          responseData = JSON.parse(
            new TextDecoder().decode(axiosError.response.data)
          );
        } catch (parseError) {
          // Parse edilemezse genel hata
        }
      } else {
        responseData = axiosError.response?.data;
      }
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Toplu sertifika için veri bulunamadı",
          correlationId: responseData?.correlationId
        } as SinavError;
      }
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId
        } as SinavError;
      }
      throw {
        message: responseData?.message || "Toplu sertifika PDF oluşturulurken bir hata oluştu",
        correlationId: responseData?.correlationId,
      } as SinavError;
    }
    throw { 
      message: (error as Error).message || "Beklenmeyen bir hata oluştu"
    } as SinavError;
  }
};